import { IUnit } from 'shared/domain/entities';

export interface IVectisUnit {
  id: number;
  bairro: string;
  nomeFantasia: string;
  latitude: string;
  longitude: string;
  logradouro: string;
  uf: string;
  numeroLogradouro: string;
  cidade: string;
  possuiItemExclusivoParaAgendamento?: boolean;
  fechada: boolean;
  linkAvaliacaoGoogle?: string;
  descricaoWeb?: string;
  fone?: string;
  hrInicioExpediente: string;
  hrFimExpediente: string;
  hrInicioAtendimentoSegundaAteSexta?: string;
  hrFimAtendimentoSegundaAteSexta?: string;
  hrInicioAtendimentoSabado?: string;
  hrFimAtendimentoSabado?: string;
  hrInicioAtendimentoDomingo?: string;
  hrFimAtendimentoDomingo?: string;
}

export class Unit implements IUnit {
  public id: IUnit['id'];
  public name: IUnit['name'];
  public locationName: IUnit['locationName'];
  public coords: IUnit['coords'];
  public address: IUnit['address'];
  public hasExclusivePackages: IUnit['hasExclusivePackages'];
  public googleEvaluationLink: IUnit['googleEvaluationLink'];
  public phone: IUnit['phone'];
  public serviceHours: IUnit['serviceHours'];

  constructor({
    id,
    nomeFantasia,
    latitude,
    longitude,
    logradouro,
    uf,
    numeroLogradouro,
    cidade,
    bairro,
    possuiItemExclusivoParaAgendamento = false,
    linkAvaliacaoGoogle,
    descricaoWeb,
    fone,
    hrFimExpediente,
    hrInicioExpediente,
    hrFimAtendimentoDomingo,
    hrFimAtendimentoSabado,
    hrFimAtendimentoSegundaAteSexta,
    hrInicioAtendimentoDomingo,
    hrInicioAtendimentoSabado,
    hrInicioAtendimentoSegundaAteSexta,
  }: IVectisUnit) {
    this.id = id;
    this.name = nomeFantasia;
    this.coords = {
      latitude,
      longitude,
    };
    this.address = {
      street: logradouro,
      number: numeroLogradouro,
      state: uf,
      city: cidade,
      district: bairro,
    };
    this.hasExclusivePackages = possuiItemExclusivoParaAgendamento;
    this.googleEvaluationLink = linkAvaliacaoGoogle;
    this.phone = fone;
    this.locationName = this.getLocationName({ descricaoWeb, nomeFantasia });
    this.serviceHours = {
      default: {
        start: hrInicioExpediente,
        end: hrFimExpediente,
      },
    };

    if (hrInicioAtendimentoSegundaAteSexta && hrFimAtendimentoSegundaAteSexta) {
      this.serviceHours.weekDays = {
        start: hrInicioAtendimentoSegundaAteSexta,
        end: hrFimAtendimentoSegundaAteSexta,
      };
    }

    if (hrInicioAtendimentoSabado && hrFimAtendimentoSabado) {
      this.serviceHours.saturdays = {
        start: hrInicioAtendimentoSabado,
        end: hrFimAtendimentoSabado,
      };
    }

    if (hrInicioAtendimentoDomingo && hrFimAtendimentoDomingo) {
      this.serviceHours.sundays = {
        start: hrInicioAtendimentoDomingo,
        end: hrFimAtendimentoDomingo,
      };
    }
  }

  private getLocationName(params: {
    descricaoWeb?: string;
    nomeFantasia: string;
  }) {
    if (params.descricaoWeb) return params.descricaoWeb;

    const [, name] = params.nomeFantasia.split(' | ');

    if (name) return name;

    return params.nomeFantasia;
  }
}
